import { CacheBuster } from "cache-controller";
import { useCache } from "hooks";
import TagManager from "react-gtm-module";
import { Helmet, HelmetProvider } from "react-helmet-async";
import { Oval } from "react-loader-spinner";
import { Bounce, ToastContainer, toast } from "react-toastify";
import "react-toastify/dist/ReactToastify.css";

import pkg from "../../package.json";
import { ErrorBoundary } from "./ErrorPage";
import { AllRoutes } from "./routes/Routes";

function App() {
  // useAutoLogoutOnTokenExpiration();

  const { clearBrowserStorage } = useCache();
  const isProduction = process.env.NODE_ENV === "production";

  if (isProduction && process.env.REACT_APP_GTM) {
    TagManager.initialize({
      gtmId: process.env.REACT_APP_GTM
    });
  }

  return (
    <CacheBuster
      currentVersion={pkg.version}
      isEnabled={isProduction} //If false, the library is disabled.
      isVerboseMode={false} //If true, the library writes verbose logs to console.
      loadingComponent={
        <div className="w-full h-full flex flex-col justify-center items-center">
          <Oval width={20} height={20} />
        </div>
      } //If not pass, nothing appears at the time of new version check.
      metaFileDirectory="." //If public assets are hosted somewhere other than root on your server.
      onCacheClear={clearBrowserStorage}
    >
      <ErrorBoundary>
        <HelmetProvider>
          <Helmet>
            <title>SplitWise</title>
            <meta name="title" content="SplitWise" />
            <meta name="description" content="SplitWise" />
          </Helmet>
          <ToastContainer position={toast.POSITION.BOTTOM_RIGHT} hideProgressBar transition={Bounce} autoClose={8000} />
          <AllRoutes />
        </HelmetProvider>
      </ErrorBoundary>
    </CacheBuster>
  );
}

export default App;
